module.exports = __webpack_public_path__ + "img/coin.7b795c19.png";